const OBJECT_URL_REVOKE_DELAY_IN_MS = 150;

export const triggerBlobDownload = (blob: Blob, fileName: string) => {
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  setTimeout(() => {
    URL.revokeObjectURL(blobUrl);
    anchor.remove();
  }, OBJECT_URL_REVOKE_DELAY_IN_MS);
};
